import Io from 'socket.io-client';
import { getToken } from 'utils/auth';

const WEBSOCKET_URL = import.meta.env.VITE_WS_API_URL ?? '';

let socket = Io(WEBSOCKET_URL, {
  reconnection: true,
  reconnectionDelay: 100,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
  transports: ['websocket'],
  auth: {
    token: getToken(),
  },
});

const getSocket = () => {
  if (!socket) {
    socket = Io(WEBSOCKET_URL, {
      reconnection: true,
      reconnectionDelay: 100,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      transports: ['websocket'],
      auth: {
        token: getToken(),
      },
    });
    socket.on('hello', data => console.log(`Hello data ${data}`));
  }

  return socket;
};

export const reconnectWithToken = (token: string | null) => {
  socket.auth = { token };
  socket.disconnect().connect();
};

socket.io.on('close', () => console.log('socket connection closed'));
socket.io.on('reconnect_attempt', () => console.log('socket reconnect attempt'));
socket.io.on('reconnect_failed', () => console.log('socket reconnect failed'));
socket.io.on('reconnect', () => console.log('socket reconnect'));

export default getSocket;
